import { isSameDay } from 'date-fns';

/*
  History filter function to use all over the screen
*/
function filterHistory(history, range, all, type) {
  if (all && type) {
    return history.filter((x) => type === x.type);
  }

  if (all) return history;

  const filtered = history.filter((x) => {
    const createdAt = new Date(x.createdAt);
    if (isSameDay(range[0], range[1])) return isSameDay(new Date(range[0]), createdAt);

    if (type && type !== x.type) return false;

    return createdAt <= new Date(range[0]) && createdAt >= new Date(range[1]);
  });

  return filtered;
}

export default filterHistory;
